import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { styled } from '../../lib/stitches'
import AuthStore from '../../stores/AuthStore'
import Avatar from '../core/Avatar'
import Text from '../core/Text/Text'
import { AddNewImage } from '../platform/icons'

type SelectProfilePictureProps = {
  onChange: (file: File) => void
  profilePicture: File | null
}

export const SelectProfilePicture = observer((props: SelectProfilePictureProps) => {
  const { user } = AuthStore
  const profilePictureInputRef = useRef<HTMLInputElement>(null)

  const { onChange, profilePicture } = props

  const onClickUploadFile = () => {
    profilePictureInputRef.current.click()
  }

  const onFileInputChange = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.files[0] !== undefined) {
      onChange(event.currentTarget.files[0])
    }
  }
  return (
    <>
      {user?.profile_picture !== undefined || profilePicture !== null ? (
        <ProfilePictureContainer onClick={onClickUploadFile}>
          <Avatar
            style={{ width: '100px', height: '100px', cursor: 'pointer' }}
            imageUrl={
              profilePicture !== undefined && profilePicture !== null
                ? URL.createObjectURL(profilePicture)
                : user?.profile_picture
            }
          />
          <HoverAddNewImage id="pfp-upload-icon" />
          <StyledText
            id="pfp-hover-text"
            size={'14'}
            type={'primary_inverted'}
            css={{ fontWeight: 'bold' }}
          >
            Add Photo
          </StyledText>
          <OverlayFilledCircle id="overlay-filled-circle" />
        </ProfilePictureContainer>
      ) : (
        <ProfilePictureContainer onClick={onClickUploadFile}>
          <FilledCircle id="filled-circle" />
          <StyledAddNewImage />
          <StyledText
            id="pfp-hover-text"
            size={'14'}
            type={'primary_inverted'}
            css={{ fontWeight: 'bold' }}
          >
            Add Photo
          </StyledText>
        </ProfilePictureContainer>
      )}

      <input
        type="file"
        ref={profilePictureInputRef}
        accept="image/png, image/jpeg, image/jpg"
        style={{ display: 'none' }}
        onChangeCapture={onFileInputChange}
      />
    </>
  )
})

const FilledCircle = styled('div', {
  height: '100px',
  width: '100px',
  borderRadius: '50%',
  backgroundColor: '$gray10'
})

const OverlayFilledCircle = styled(FilledCircle, {
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  zIndex: 2
})

const StyledAddNewImage = styled(AddNewImage, {
  position: 'absolute',
  top: '28%',
  left: '28%'
})

const HoverAddNewImage = styled(StyledAddNewImage, {
  opacity: 0,
  zIndex: 3
})

const ProfilePictureContainer = styled('div', {
  position: 'relative',
  cursor: 'pointer',
  '&:hover #overlay-filled-circle': {
    opacity: 0.4
  },
  '&:hover #filled-circle': {
    opacity: 0.8
  },
  '&:hover #pfp-hover-text': {
    opacity: 1
  },
  '&:hover #pfp-upload-icon': {
    opacity: 1
  }
})

const StyledText = styled(Text, {
  position: 'absolute',
  top: '67%',
  left: '15%',
  zIndex: 3,
  opacity: 0
})
